import * as THREE from "three";
import roboto from "Assets/font/roboto.json";
import { DoubleSide } from "three";
import theme from "Styles/theme";

const LOGOLETTER = " PROJECT";
const LOGO_ARR = LOGOLETTER.split("");
const LOGO_SIZE = 32;
const LOGO_RADIUS = LOGO_SIZE * 3.5;
const LOGO_SPEED = 0.001;

export default (scene: any) => {
	// -LOGO
	const loader = new THREE.FontLoader();
	const font = loader.parse(roboto);
	const logo_mat = new THREE.MeshLambertMaterial({
		// emissive: 0xa0808,
		color: theme.color.logo,
		side: DoubleSide
	});

	const logo_arr = LOGO_ARR.map((text, index) => {
		const logo_geo = new THREE.TextBufferGeometry(text, {
			font: font,
			size: LOGO_SIZE * 2,
			height: LOGO_SIZE
		});

		const letter = new THREE.Mesh(logo_geo, logo_mat);

		var box = new THREE.Box3().setFromObject(letter);
		box.getCenter(letter.position);
		letter.position.multiplyScalar(-1);
		const letter_pivot = new THREE.Group();
		letter_pivot.add(letter);
		scene.add(letter_pivot);

		letter_pivot.position.x = Math.sin(((Math.PI * 2) / LOGO_ARR.length) * (index - 2)) * LOGO_RADIUS;
		letter_pivot.position.y = Math.cos(((Math.PI * 2) / LOGO_ARR.length) * (index - 2)) * LOGO_RADIUS;
		letter_pivot.position.z = theme.zIndex.three.logo;

		letter_pivot.rotation.y = Math.PI * Math.random();
		letter_pivot.rotation.z = Math.PI * Math.random();
		return {
			mesh: letter_pivot,
			speed: {
				x: Math.abs(Math.random() * LOGO_SPEED),
				y: Math.abs(Math.random() * LOGO_SPEED),
				z: Math.abs(Math.random() * LOGO_SPEED)
			}
		};
	});

	return logo_arr;
};

export const logoAnimation = (logo_arr: any, framecount: number) => {
	logo_arr.forEach((t: any, index: number) => {
		t.mesh.position.x = Math.sin(framecount * 0.0005 + ((Math.PI * 2) / LOGO_ARR.length) * (index - 2)) * LOGO_RADIUS;
		t.mesh.position.y = Math.cos(framecount * 0.0005 + ((Math.PI * 2) / LOGO_ARR.length) * (index - 2)) * LOGO_RADIUS;
		t.mesh.rotation.x += t.speed.x;
		t.mesh.rotation.y += t.speed.y;
		t.mesh.rotation.z += t.speed.z;
	});
};
